import { dashboardMenu, demoPages, layoutMenu } from '../menu';
// import DashboardHeader from '../pages/common/Headers/DashboardHeader';
import DefaultHeader from '../pages/common/Headers/DefaultHeader';
import Header404 from '../pages/common/Headers/Header404';

const headers = [
	{ path: layoutMenu.pageLayout.subMenu.onlySubheader.path, element: null, exact: true },
	{ path: layoutMenu.pageLayout.subMenu.onlyContent.path, element: null, exact: true },
	{ path: layoutMenu.blank.path, element: null, exact: true },
	{ path: demoPages.login.path, element: null, exact: true },
	{ path: demoPages.signUp.path, element: null, exact: true },
	{ path: demoPages.page404.path, element: <Header404 />, exact: true },
	// { path: dashboardMenu.dashboard.path, element: <DashboardHeader />, exact: true },
	{ path: dashboardMenu.dashboard.path, element: <DefaultHeader />, exact: true },
	// {
	// 	path: `*`,
	// 	element: <DashboardHeader />,
	// },
	{
		path: `*`,
		element: <DefaultHeader />,
	},
];

export default headers;
